{
  "got-it": "Entendido",
  "mercury.email.footer.sent-by": "Este mensaje te lo ha enviado Atlassian Focus",
  "mercury.email.footer.unsubscribe": "Anular suscripción",
  "mercury.focus-areas.arrow-icon.alt": "icono-flecha",
  "mercury.focus-areas.arrow-right-icon.alt": "icono-flecha-derecha",
  "mercury.focus-areas.calendar-icon.alt": "icono-calendario",
  "mercury.focus-areas.date-changed": "Fecha cambiada",
  "mercury.focus-areas.focus-area.alt": "icono-área-enfoque",
  "mercury.focus-areas.focus-footer.alt": "Pie de página de Atlassian",
  "mercury.focus-areas.focus-icon.alt": "Icono de área de enfoque",
  "mercury.focus-areas.for": "for",
  "mercury.focus-areas.heading": "You're following {total} active focus areas, here's the breakdown.",
  "mercury.focus-areas.no-target-date.alt": "No se ha fijado ninguna fecha prevista",
  "mercury.focus-areas.status-changed": "Estado cambiado",
  "mercury.focus-areas.view-area": "Ver área de enfoque",
  "mercury.focus.catch.up.link": "Ir a Atlassian Focus",
  "mercury.focus.catch.up.text": "¿Quieres ver actualizaciones anteriores? {link}",
  "mercury.mercury-monthly-digest.message-template.email.subject.no-translate": "{name}, aquí están las actualizaciones mensuales de tu área de enfoque",
  "mercury.message-templates.edit-focus-area-heirarchy-spotlight-body": "Siempre que debas hacer cambios en tu jerarquía, puedes hacerlo desde la configuración.",
  "mercury.message-templates.edit-focus-area-heirarchy-spotlight-heading": "Edita la jerarquía de tu área de enfoque"
}